import { ProviderId } from 'firebase/auth';
import Cookie from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { osVersion, osName, browserName } from 'react-device-detect';

// Import helpers
import { CURRENT_SYSTEM } from 'helpers/operators';
import { getDeviceUID } from 'helpers/headers';

// Import types
import { ErrorCodes } from 'types/api/errors';

export const checkAuthorizationError = ({ response }: any) => {
	const errorStatus = response?.status;
	const data = response?.data;
	const statusCode = data?.status?.code;
	const isMultipleAccount = statusCode === ErrorCodes.MULTIPLE_ACCOUNT_AVAILABLE;
	const isExternalProviderError = data.errorCode === ErrorCodes.SUBSCRIBER_EXTERNAL_PROVIDER_RECORD_NOT_FOUND;
	const isAuthorizationError = errorStatus !== 409;
	return {
		data,
		isMultipleAccount,
		isAuthorizationError,
		isExternalProviderError
	};
};

export const getInitialLoginValues = () => {
	const uid: string = getDeviceUID();

	return {
		system: CURRENT_SYSTEM,
		os: osName,
		osVersion,
		maker: 'unknown',
		agent: browserName,
		uid
	};
};

export const AUTH_PROVIDERS = [
	{
		name: 'Facebook',
		providerId: ProviderId.FACEBOOK,
		icon: 'ic_auth_facebook'
	},
	{
		name: 'Google',
		providerId: ProviderId.GOOGLE,
		icon: 'ic_auth_google'
	},
	{
		name: 'Apple',
		providerId: 'apple.com',
		icon: 'ic_auth_apple'
	}
];

export const getUserToken = () => Cookie.get('token') ?? null;

export const setUserToken = (token: string) => {
	const { exp } = jwtDecode(token);
	const expires = exp ? new Date(exp * 1000) : 0;
	Cookie.set('token', token, { expires });
};

export const removeUserToken = () => Cookie.remove('token');
